"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplaceContractResponseDtoModeEnum = void 0;
exports.instanceOfReplaceContractResponseDto = instanceOfReplaceContractResponseDto;
exports.ReplaceContractResponseDtoFromJSON = ReplaceContractResponseDtoFromJSON;
exports.ReplaceContractResponseDtoFromJSONTyped = ReplaceContractResponseDtoFromJSONTyped;
exports.ReplaceContractResponseDtoToJSON = ReplaceContractResponseDtoToJSON;
exports.ReplaceContractResponseDtoToJSONTyped = ReplaceContractResponseDtoToJSONTyped;
/**
 * @export
 */
exports.ReplaceContractResponseDtoModeEnum = {
    Preview: 'preview',
    Replace: 'replace'
};
/**
 * Check if a given object implements the ReplaceContractResponseDto interface.
 */
function instanceOfReplaceContractResponseDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('mode' in value) || value['mode'] === undefined)
        return false;
    return true;
}
function ReplaceContractResponseDtoFromJSON(json) {
    return ReplaceContractResponseDtoFromJSONTyped(json, false);
}
function ReplaceContractResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'mode': json['mode'],
        'file': json['file'] == null ? undefined : json['file'],
    };
}
function ReplaceContractResponseDtoToJSON(json) {
    return ReplaceContractResponseDtoToJSONTyped(json, false);
}
function ReplaceContractResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'mode': value['mode'],
        'file': value['file'],
    };
}
